module.exports = vendor_23e55280757b464716ca;


//////////////////
// WEBPACK FOOTER
// external "vendor_23e55280757b464716ca"
// module id = 36
// module chunks = 0